import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Card, CardHeader, Collapse } from 'reactstrap';

const column1 = [
  {
    Header: 'Part Number',
    accessor: 'partNum',
  },
  {
    Header: 'NIIN',
    accessor: 'niin',
  },
  {
    Header: 'Part Description',
    accessor: 'description',
  },
  {
    Header: 'Company Name',
    accessor: 'toolLocation',
  },
  {
    Header: 'WSDC',
    accessor: 'wsdc',
  },
  {
    Header: 'Visibility',
    accessor: 'accessLevel',
    Cell: (row => <div><span>{Object.values(JSON.parse(row.original.accessLevel))[0] || '-'}</span></div>),
  },
  {
    Header: 'Category',
    accessor: 'category',
    Cell: (row => <div><span >{Object.keys(JSON.parse(row.original.category))[0] || '-'} - {Object.values(JSON.parse(row.original.category))[0] || '-'}</span></div>),
  },
];

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);

  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Search Summary {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>
      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/historyTables/ToolingSearch.jsx